import React from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ModalCloseButton,
  Button,
  Flex,
  Icon,
  Text,
  Stack,
  Tag,
  TagLabel,
  Box,
  Divider,
} from '@chakra-ui/react';
import { LockIcon } from '@chakra-ui/icons';

const REASON_LABELS = {
  periodo_cerrado: 'Período cerrado',
  liquidacion_enviada: 'Liquidación enviada',
};

const toTitleCase = (value = '') =>
  value
    .toString()
    .toLocaleLowerCase('es-AR')
    .replace(/_/g, ' ')
    .replace(/\b\w/g, (char) => char.toLocaleUpperCase('es-AR'));

const PeriodLockedModal = ({ isOpen, payload, onClose, onNavigate }) => {
  const error = payload || {};
  const meta = error.meta || {};

  const periodLabel = meta.periodo_label ? toTitleCase(meta.periodo_label) : 'Período seleccionado';
  const reasonKey = meta.locked_reason || error.locked_reason;
  const reasonLabel = reasonKey ? REASON_LABELS[reasonKey] || toTitleCase(reasonKey) : null;
  const rangeText =
    meta.fecha_inicio && meta.fecha_fin ? `${meta.fecha_inicio} → ${meta.fecha_fin}` : null;

  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered size="lg" motionPreset="scale">
      <ModalOverlay bg="blackAlpha.600" />
      <ModalContent>
        <ModalHeader>
          <Flex align="center" gap={3}>
            <Icon as={LockIcon} color="purple.500" boxSize={5} />
            <Text>Período bloqueado</Text>
          </Flex>
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Stack spacing={4}>
            <Text color="gray.600">
              {error.message ||
                'No se pueden realizar cambios porque el período está bloqueado por la administración.'}
            </Text>
            <Box>
              <Text fontWeight="semibold">Período</Text>
              <Text>{periodLabel}</Text>
            </Box>
            {rangeText && (
              <Box>
                <Text fontWeight="semibold">Rango</Text>
                <Text>{rangeText}</Text>
              </Box>
            )}
            {reasonLabel && (
              <Tag size="lg" colorScheme="purple" width="fit-content">
                <TagLabel>{reasonLabel}</TagLabel>
              </Tag>
            )}
            <Divider />
            <Text fontSize="sm" color="gray.500">
              Si necesitás continuar, revisá la liquidación o abrí el período correspondiente desde la
              sección de Períodos.
            </Text>
          </Stack>
        </ModalBody>
        <ModalFooter gap={3}>
          {typeof onNavigate === 'function' && (
            <Button variant="outline" onClick={onNavigate}>
              Ir a períodos
            </Button>
          )}
          <Button colorScheme="purple" onClick={onClose}>
            Entendido
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default PeriodLockedModal;
